<template>
  <div>
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div
      class="modal fade"
      id="UpdateAudioBookModal"
      tabindex="-1"
      aria-labelledby="UpdateChannelModalLabel"
      aria-hidden="true"
      data-keyboard="false"
      data-backdrop="static"
    >
      <div class="modal-dialog modal-dialog-centered" v-if="showForm">
        <div class="modal-content AddNewChannelModal_content border-0">
          <div class="modal-header AddNewChannelModal_header">
            <h5 class="modal-title" id="UpdateChannelModalLabel">
              <img
                src="../../assets/images/left.svg"
                class="me-2"
                width="20"
                height="20"
              />
              Update AudioBook {{id}}
            </h5>
            <button
              type="button"
              class="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <form @submit.prevent="processForm" method="put">
            <!-- error messages for form validation -->
            <div class="modal-body">
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label"
                      >AudioBook Name</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="a_name"
                      v-model="name"
                      id="a_name"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="en_name" class="form-label"
                      >AudioBook EnName</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="en_name"
                      v-model="en_name"
                      id="en_name"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Author Name</label>
                  </div>
                  <div class="col-12 col-md-8">
<!--                    <input-->
<!--                      type="text"-->
<!--                      class="form-control bg-input border-0"-->
<!--                      name="aName"-->
<!--                      v-model="authorName"-->
<!--                      id="aName"-->
<!--                    />-->
                    <Select2
                        class="text-black"
                        v-model="authorName"
                        :options="authorList"
                        :settings="{
                        width: '100%',
                      placeholder: 'Select Contribute',
                      multiple: true,
                    }"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Vocal Artist</label>
                  </div>
                  <div class="col-12 col-md-8">
<!--                    <input-->
<!--                      type="text"-->
<!--                      class="form-control bg-input border-0"-->
<!--                      name="vArtist"-->
<!--                      v-model="vocalArtist"-->
<!--                      id="vArtist"-->
<!--                    />-->
                    <Select2
                        class="text-black"
                        v-model="vocalArtist"
                        :options="castList"
                        :settings="{
                      width: '100%',
                      placeholder: 'Select Contribute',
                      multiple: true,
                    }"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label class="form-label">Add Publisher</label>
                  </div>
                  <div class="col-12 col-md-8">

                    <Select2
                        class="text-black"
                        v-model="publisher_id"
                        :options="publisherList"
                        :settings="{
                      width: '100%',
                        placeholder: 'Select Publisher'
                    }"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Price</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="vArtist"
                      v-model="price"
                      id="vArtist"
                    />
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label class="typo__label">Category</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <multiselect
                      v-model="categoryValue"
                      tag-placeholder="Add this as new tag"
                      placeholder="Select category"
                      :options="categories"
                      label="name"
                      track-by="id"
                      :multiple="true"
                    ></multiselect>
                    <!-- <pre
                      class="language-json"
                    ><code>{{ categoryValue  }}</code></pre> -->
                  </div>
                </div>
              </div>

              <!-- <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label class="form-label star_after">Category</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <select
                      v-model="selectCategoryId"
                      type="text"
                      class="form-select bg-input border-0"
                    >
                      <option
                        style="display: none"
                        selected="selected"
                        value=""
                      >
                        {{ audioBookCategory }}
                      </option>
                      <option
                        v-for="(category, index) in categories"
                        :key="index"
                        :value="category.id"
                      >
                        {{ category.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div> -->
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label">Description</label>
                  </div>
                  <div class="col-12 col-md-8">
                    <textarea
                      class="form-control bg-input border-0"
                      v-model="description"
                      name="description"
                      id="description"
                      cols="15"
                      rows="5"
                    ></textarea>
                    <!-- <input
                      type="text"
                      class="form-control bg-input border-0"
                      name="c_name"
                      v-model="description"
                      id="c_name"
                    /> -->
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_name" class="form-label"
                      >Present Thumb Image</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <img
                      v-bind:src="audioBookImage"
                      height="80px"
                      width="120px"
                    />
                  </div>
                </div>
              </div>
              <div class="mb-3">
                <div class="row align-items-center">
                  <div class="col-12 col-md-4">
                    <label for="c_image" class="form-label"
                      >Update Thumb Image</label
                    >
                  </div>
                  <div class="col-12 col-md-8">
                    <input
                      class="form-control bg-input border-0"
                      type="file"
                      name="c_image"
                      id="c_image"
                      aria-describedby="imageHelp"
                      accept="image/jpeg, image/png"
                      @change="onImageFileChange"
                    />
                    <div id="imageHelp" class="form-text">
                      * Preferred image ratio 1:1 (ex. 512px * 512px Or 1200px *
                      1200px)
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                type="reset"
                class="btn btn-secondary btn-sm"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button type="submit" class="btn btn-primary btn-sm">
                Submit
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Loading from "vue-loading-overlay";
export default {
  name: "UpdateAudioBookModal",
  components: { Loading },
  props: [
    "audioBookId",
    "audioBookImage",
    "audioBookName",
    "audioBookEnName",
    "audioBookCategoryId",
    "audioBookCategory",
    "audioBookAuthor",
    "audioBookArtist",
    "audioBookPublisher_id",
    "audioDescription",
    "audioBookPrice"
  ],
  data() {
    return {
      errors: [],
      castList: [],
      publisherList:[],
      authorList: [],
      categoryValue: [],
      checkCategoryValue: [],
      name: null,
      en_name: null,
      description: null,
      authorName: null,
      vocalArtist: null,
      publisher_id: undefined,
      selectedImageFile: undefined,
      showForm: true,
      categories: [],
      compareCategory: [],
      selectCategoryId: "",
      id: null,
      //for loader
      isLoading: false,
      fullPage: true,
      loader: "bars",
      price:null
    };
  },
  async mounted() {
    await this.getData();
    await this.getCast();
    await this.getAuthorList();
    await this.getPublisher();
  },
  watch: {
    audioBookName: function (newVal, oldVal) {
      this.name = this.audioBookName;
      this.en_name = this.audioBookEnName;
      this.authorName = this.audioBookAuthor.split(",");
      this.vocalArtist = this.audioBookArtist.split(",");
      this.publisher_id = this.audioBookPublisher_id;
      this.description = this.audioDescription;
      this.id = this.audioBookId;
      this.price = this.audioBookPrice
      console.log(this.price)
      if(this.id){
        this.getAssignedCategory();
      }
    },
  },
  methods: {
    onImageFileChange(event) {
      this.selectedImageFile = event.target.files[0];
    },
    processForm() {
      //console.log(this.selectCategoryId);
      //console.log(this.selectedImageFile);
      if (this.categoryValue.length == this.checkCategoryValue.length) {
      }
      if (this.selectedImageFile) {
        this.postWithImage();
      } else {
        this.postWithoutImage();
      }
    },

    async postWithImage() {
      //console.log(this.selectCategoryId);
      let categoryVal = JSON.stringify(this.categoryValue);
      let compareCategory = JSON.stringify(this.compareCategory);
      this.isLoading = true;
      const formData = new FormData();
      formData.append("name", this.name);
      formData.append("en_name", this.en_name);
      formData.append("authorName", this.authorName.toString());
      formData.append("vocalArtist", this.vocalArtist.toString());
      formData.append("publisher_id", this.publisher_id);
      //formData.append("category_id", this.selectCategoryId);
      formData.append("compareCategory", compareCategory);
      formData.append("categoryValue", categoryVal);
      formData.append("description", this.description);
      formData.append("files", this.selectedImageFile);
      formData.append("price", this.price)
      formData.forEach((element) => {
        //console.log(element);
      });
      //formData.append("description", this.description);
      //console.log(this.selectedImageFile)
      const token = localStorage.getItem(this.$tokenKey);
      this.showForm = false;
      try {
        const res = await axios.put(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/update/" +
            this.audioBookId,
          formData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        this.isLoading = false;
        if (res.data.success == true) {
          // this.$router.go();
        } else {
          this.$vToastify.info(
            "Something went wrong, please refresh and try again."
          );
        }
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async postWithoutImage() {
      //console.log(this.categoryValue);
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const putMethod = {
          method: "PUT", // Method itself
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-type": "application/json; charset=UTF-8", // Indicates the content
          },
          body: JSON.stringify({
            name: this.name,
            en_name: this.en_name,
            authorName: this.authorName.toString(),
            vocalArtist: this.vocalArtist.toString(),
            publisher_id: this.publisher_id,
            categoryValues: this.categoryValue,
            compareCategories: this.compareCategory,
            description: this.description,
            price: this.price,
          }), // We send data in JSON format
        };
        //make the HTTP put request using fetch api asdf
        fetch(
          this.$baseUrl +
            this.$api +
            this.$version1 +
            "/audiobooks/update/" +
            this.audioBookId +
            "/without-image",
          putMethod
        )
          .then((response) => response.json())
          .then((data) => {
            if (data.success == true) {
              this.$router.go();
            } else {
              this.$vToastify.info(
                "Something went wrong, please refresh and try again."
              );
            }
          }) // Manipulate the data retrieved back, if we want to do something with it
          .catch((err) => console.log(err));
        this.isLoading = false;
        this.showForm = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async getData() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl + this.$api + this.$version1 + "/categories/admin",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.status == 200) {
        this.categories = res.data.map((el) => {
          return { id: el.id, name: el.name };
        });
        this.isLoading = false;
      }
    },
    async getAssignedCategory() {
      //console.log(this.audioBookId);
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
        this.$baseUrl +
          this.$api +
          this.$version1 +
          "/audiobooks/get-assigned-category/" +
          this.id,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      console.log(res.data);
      if (res.status == 200) {
        this.categoryValue = res.data.data.map((el) => {
          return { id: el.id, name: el.name };
        });
        // console.log(this.categoryValue)
        this.compareCategory = res.data.data.map((el) => {
          return { ca_id: el.ca_id };
        });
        //console.log(this.compareCategory);
        this.isLoading = false;
      }
    },
    async getCast() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks/castcrew/getall",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );
      if (res.status === 200) {
        this.castList = res.data.data.map((el) => {
          return el.name;
        });
        this.isLoading = false;
      }
    },
    async getAuthorList() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/audiobooks/authors/getall",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );
      if (res.status === 200) {
        this.authorList = res.data.data.map((el) => {
          return el.name;
        });
        this.isLoading = false;
      }
    },
    async getPublisher() {
      this.isLoading = true;
      const token = localStorage.getItem(this.$tokenKey);
      const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/publishers/publisherslist",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
      );
      if (res.status === 200) {
        this.publisherList = res.data.map((el) => {
          return { id: el.id, text: el.en_name};
        });
        this.isLoading = false;
      }
    },
  }
};
</script>


<style scoped>
span.select2-container {
  z-index:10050;
}
.modal-open .select2-dropdown {
  z-index: 10060;
}

.modal-open .select2-close-mask {
  z-index: 10055;
}
</style>
